import { W, H, R } from "./props";

export const DESCENT_DURATION = 13;
const CAPTIONS = [
  [0.6, 3.6, "Behind the iron door, stone stairs wind down into the mountain."],
  [4.0, 7.0, "Dana looks back once. Then she follows Samantha down."],
  [7.4, 10.4, "Their lanterns grow smaller. And smaller."],
  [10.8, 12.6, "And then they are gone."],
];
export const descentCaption = (tt) => (CAPTIONS.find(([a, b]) => tt >= a && tt <= b) || [])[2] || null;

function lantern(ctx, x, y, a, t) {
  const g = ctx.createRadialGradient(x, y, 0, x, y, 18);
  g.addColorStop(0, `rgba(245,158,11,${0.55 * a})`); g.addColorStop(1, "rgba(245,158,11,0)");
  ctx.fillStyle = g; ctx.fillRect(x - 18, y - 18, 36, 36);
  R(ctx, `rgba(253,224,71,${a})`, x - 1, y - 1 + Math.round(Math.sin(t / 90)), 2, 2);
}

export function drawDescent(ctx, tt, now) {
  R(ctx, "#060505", 0, 0, W, H);
  R(ctx, "#2b2b2d", 0, 0, 90, H); R(ctx, "#2b2b2d", W - 90, 0, 90, H); R(ctx, "#1f1f21", 0, 0, W, 22);
  R(ctx, "#3a3a3e", 86, 22, 8, 130); R(ctx, "#3a3a3e", W - 94, 22, 8, 130); R(ctx, "#4a4a50", 86, 22, W - 172, 6);
  R(ctx, "#5a3a2a", 60, 40, 24, 100); R(ctx, "#3d2a1c", 64, 46, 16, 88); R(ctx, "#9ca3af", 78, 88, 3, 6);
  for (let i = 0; i < 12; i++) {
    const w = 140 - i * 10, y = 150 - i * 9, x = W / 2 - w / 2;
    R(ctx, `rgb(${58 - i * 4},${54 - i * 4},${50 - i * 4})`, x, y, w, 3); R(ctx, "#121111", x, y + 3, w, 6);
  }
  const p = Math.min(1, Math.max(0, (tt - 3.6) / 8));
  [[0, 0], [1, 0.12]].forEach(([k, lag]) => {
    const q = Math.min(1, Math.max(0, p - lag)), x = W / 2 + (k ? 6 : -6) * (1 - q), y = 140 - q * 96, s = 1 - q * 0.8, a = q > 0.92 ? (1 - q) / 0.08 : 1;
    if (a <= 0) return;
    ctx.globalAlpha = a;
    R(ctx, k ? "#5c0f0f" : "#2f4a6b", x - 3 * s, y - 14 * s, 6 * s, 14 * s); R(ctx, k ? "#4a2a18" : "#1a1210", x - 2 * s, y - 18 * s, 4 * s, 4 * s);
    ctx.globalAlpha = 1;
    lantern(ctx, x + 4 * s, y - 9 * s, a, now + k * 300);
  });
  R(ctx, "#030303", 100, 150, 9, 30); R(ctx, "#030303", 101, 142, 7, 8);
  const v = ctx.createRadialGradient(W / 2, H / 2, 40, W / 2, H / 2, 190);
  v.addColorStop(0, "rgba(0,0,0,0)"); v.addColorStop(1, "rgba(0,0,0,0.85)"); ctx.fillStyle = v; ctx.fillRect(0, 0, W, H);
  R(ctx, "#000", 0, 0, W, 16); R(ctx, "#000", 0, H - 16, W, 16);
  const fade = tt < 0.8 ? 1 - tt / 0.8 : tt > DESCENT_DURATION - 1 ? tt - (DESCENT_DURATION - 1) : 0;
  if (fade > 0) { ctx.fillStyle = `rgba(0,0,0,${Math.min(1, fade)})`; ctx.fillRect(0, 0, W, H); }
}
